import ReservationInfo from './reservation-info';

export default ReservationInfo;
